import type {
  ApiEnvironment,
  ApiUser,
} from 'api/userEnvironment/types/ApiUserEnvironment';
import type { UserDashboardApiApplicantProfile } from 'modules/userDashboard/api/applicantProfile/types/UserDashboardApiApplicantProfile';
import type { UserDashboardApiEmptyApplicantProfile } from 'modules/userDashboard/api/applicantProfile/types/UserDashboardApiEmptyApplicantProfile';
import { isNonAdmin } from 'utils/userEnvironment';

export function hasResumeDb(
  user: ApiUser | null,
  environment: ApiEnvironment | null,
) {
  return Boolean(
    (environment?.isUS || user?.isRecruitable) && CURRENT_LOCALE() === 'en',
  );
}

export function hasWorkHistoryJobs(
  profile:
    | UserDashboardApiApplicantProfile
    | UserDashboardApiEmptyApplicantProfile,
): boolean {
  return Boolean(
    profile?.workHistoryJobs && profile.workHistoryJobs.length > 0,
  );
}

export function promoteResumeDatabase(
  user: ApiUser | null,
  environment: ApiEnvironment,
) {
  if (!hasResumeDb(user, environment)) {
    return false;
  }

  if (user && !isNonAdmin(user)) {
    return false;
  }

  if (user?.isRecruitable === false || (user?.isRecruitable && user.resumeId)) {
    return false;
  }

  return true;
}
